import * as React from 'react';

import { Head } from '../Head';

type AdminLayoutProps = {
  children: React.ReactNode;
  title: string;
};

export const AdminLayout = ({ children, title }: AdminLayoutProps) => {
  return (
    <>
      <Head title={title} />
      <div className="admin-container">
        <h3 className="text-black f-18 mb-4">{title}</h3>
        {children}
      </div>
    </>
  );
};
